"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var Pagination_1 = tslib_1.__importDefault(require("../Pagination"));
var utils_1 = require("../utils");
var hooks_1 = require("./hooks");
function Pagination(props) {
    var currentPage = props.currentPage, total = props.total, _a = props.pageSize, pageSize = _a === void 0 ? 10 : _a, onChange = props.onChange;
    var prefix = hooks_1.useTable().prefix;
    function handleChange(nextPage, nextPageSize) {
        if (nextPageSize === pageSize) {
            onChange === null || onChange === void 0 ? void 0 : onChange(nextPage, nextPageSize);
        }
        else {
            // 如果有切换 pageSize 的行为，则重置页码
            onChange === null || onChange === void 0 ? void 0 : onChange(0, nextPageSize);
        }
    }
    return (react_1.default.createElement("div", { className: utils_1.concat(prefix, 'pagination') },
        react_1.default.createElement(Pagination_1.default, { current: currentPage, total: total, pageSize: pageSize, showSizeChanger: true, onChange: handleChange })));
}
exports.default = Pagination;
//# sourceMappingURL=Pagination.js.map